import * as XLSX from 'xlsx';
import {
  aggregateSchedulePlanByBumperNumber,
  formatLocation,
} from './dataFormatters';
import { convertUtcToDisplayTime } from 'utils/helpers/dateTime';
import { type preferredTimeDisplayModeTypes } from 'types/customer.types';
import { type PlanDataType } from '../CreateDispatchPlan/Steps/types/steps.types';

const formatPlanRecord = (
  record: PlanDataType,
  preferredTimeDisplayMode: preferredTimeDisplayModeTypes,
  timezone: string,
  isIndividualAssetSheet: boolean
) => {
  const base = {
    'Start Time': convertUtcToDisplayTime(
      record.start_ts,
      preferredTimeDisplayMode,
      timezone,
      'HH:mm'
    ),
    'End Time': convertUtcToDisplayTime(
      record.end_ts,
      preferredTimeDisplayMode,
      timezone,
      'HH:mm'
    ),
    'Start Location': record.start_location
      ? formatLocation(record.start_location)
      : '',
    'End Location': record.end_location
      ? formatLocation(record.end_location)
      : '',
    Action: record.action,
    'Material Picked (Ton)':
      record.action === 'loading' ? record?.material_dumped : null,
  };

  // Only add "Bumper Number" if NOT an individual sheet
  return isIndividualAssetSheet
    ? base
    : { 'Bumper Number': record.bumper_number, ...base };
};

export const exportPlanDataToExcel = (
  planData: PlanDataType[],
  fileName = 'PlanData.xlsx',
  preferredTimeDisplayMode: preferredTimeDisplayModeTypes,
  timezone: string
) => {
  const workbook = XLSX.utils.book_new();
  const { groupedPlanData: aggregatedData } =
    aggregateSchedulePlanByBumperNumber(planData);

  const allDataSheet = XLSX.utils.json_to_sheet(
    planData.map((r) =>
      formatPlanRecord(r, preferredTimeDisplayMode, timezone, false)
    )
  );
  XLSX.utils.book_append_sheet(workbook, allDataSheet, 'All_Fleet');

  Object.entries(aggregatedData).forEach(([bumper, records]) => {
    const formattedRecords = records.map((r) =>
      formatPlanRecord(r, preferredTimeDisplayMode, timezone, true)
    );

    const worksheet = XLSX.utils.json_to_sheet(formattedRecords);

    XLSX.utils.book_append_sheet(workbook, worksheet, bumper.slice(0, 31));
  });

  XLSX.writeFile(workbook, fileName);
};
